import React, { useCallback, useEffect, useMemo } from 'react';
import * as PropTypes from 'prop-types';
import ListItem from '@material-ui/core/ListItem';
import { useFormikContext } from 'formik';
import Form from '../../form/components/Form';
import MailDraftFilterPanel from './MailDraftFilterPanel';
import { IdPropType } from '../../../proptypes/basic';
import FormPersist from '../../form/components/FormPersist';
import FormAutoSubmit from '../../form/components/FormAutoSubmit';
import { Grid } from '@material-ui/core';
import MailFolderFilter from './MailFolderFilter';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
    container: {
        width: '100%',
    },

    select: {
        width: `calc(100% - 100px)`,
    },

    switch: {
        width: 100,
    },
});

const MailDraftFilterForm = ({ customerId, onSubmit }) => {
    const { values } = useFormikContext();
    const PERSIST_KEY = useMemo(() => `MailDraftFilter.${customerId}`, [customerId]);

    const handleFilter = useCallback(
        ({ filterByText }) => {                
            onSubmit({
                filterByText,
            });
        },
        [onSubmit]
    );

    useEffect(() => {
        handleFilter(values);
    }, [values, handleFilter]);

    return (
        <>
            <FormPersist persistKey={PERSIST_KEY} />
            <FormAutoSubmit />
            <MailDraftFilterPanel />
        </>
    );
};

MailDraftFilterForm.propTypes = {
    customerId: IdPropType,
    onSubmit: PropTypes.func.isRequired,
};

MailDraftFilterForm.defaultProps = {
    customerId: null,
};

const MailDraftFilter = ({
    customerId,
    onSubmit,
    initialValues,
    selectedFolder,
    onChangeFolder,
}) => {
    const classes = useStyles();

    return (
        <ListItem divider>
            <Grid container direction="row" wrap="wrap" spacing={2} className={classes.container}>
                <MailFolderFilter
                    selectedFolder={selectedFolder}
                    onChangeFolder={onChangeFolder}
                />
                <Grid item xs={12} className={classes.select}>
                    <Form initialValues={initialValues} onSubmit={() => {}}>
                        <MailDraftFilterForm customerId={customerId} onSubmit={onSubmit} />
                    </Form>
                </Grid>
            </Grid>
        </ListItem>
    );
};

MailDraftFilter.propTypes = {
    customerId: IdPropType,
    onSubmit: PropTypes.func.isRequired,
    initialValues: PropTypes.shape({
        filterByFolder: PropTypes.string,
        filterByText: PropTypes.string,
    }).isRequired,
    selectedFolder: PropTypes.string.isRequired,
    onChangeFolder: PropTypes.func.isRequired,
};

MailDraftFilter.defaultProps = {
    customerId: null,
};

export default MailDraftFilter;
